import type { FC } from "react";
import React from "react";
import { Box } from "@edreamsodigeo/prisma-design-system";

import type { ExtraContent } from "~/components/acquisition/Lightbox/LightboxRevamp/components/LightboxBenefits/types";
import BenefitsByCategory from "~/components/acquisition/Lightbox/LightboxRevamp/components/LightboxBenefits/components/BenefitsByCategory";
import AccordionItemDesktop from "./AccordionItemDesktop";
import CategorySectionDesktop from "./CategorySectionDesktop/CategorySectionDesktop";

export interface LightBoxBenefitsDesktopProps {
  extraElements?: ExtraContent[];
}

const LightBoxBenefitsDesktop: FC<LightBoxBenefitsDesktopProps> = ({
  extraElements,
}) => {
  return (
    <Box mx={"1x_big"} mb={"big"}>
      <BenefitsByCategory
        extraElements={extraElements}
        AccordionItem={AccordionItemDesktop}
        CategorySection={CategorySectionDesktop}
      />
    </Box>
  );
};

export default LightBoxBenefitsDesktop;
